import React from 'react';

import { Text } from './styles';

export default function StepInfo({ text }) {
  return <Text>{text}</Text>;
}
